// @ts-nocheck

import React, { useCallback, useMemo } from 'react';

import DERegistrationImageDesktop from '../../assets/img/register-modal/Landing_1800x1350_DE.jpg';
import ENRegistrationImageDesktop from '../../assets/img/register-modal/Landing_1800x1350_EN.jpg';
import FRRegistrationImageDesktop from '../../assets/img/register-modal/Landing_1800x1350_FR.jpg';
import DERegistrationImageMobile from '../../assets/img/register-modal/Visuel-Inscription-Depot_DE.jpg';
import ENRegistrationImageMobile from '../../assets/img/register-modal/Visuel-Inscription-Depot_EN.jpg';
import FRRegistrationImageMobile from '../../assets/img/register-modal/Visuel-Inscription-Depot_FR.jpg';
import { Target } from '../../client';
import { getRedirectUrl, RedirectServices } from '../../config/urls';
import useRouter from '../../hooks/useRouter';
import { getLang } from '../../i18n/l10n';
import { Locales } from '../../types/common';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import RegisterDefaultModal from '../RegisterDefaultModal';

type Props = {
  openExternalLink: (...params: unknown) => unknown;
  onClose?: (...params: unknown) => unknown;
};

// Component
const RegisterModal = ({ openExternalLink, onClose }: Props) => {
  const { history } = useRouter();
  const lang = getLang();

  let registerUrl = getRedirectUrl(RedirectServices.REGISTER);
  if (Target.__MOBILE__) {
    registerUrl += '&mobile=1';
  }

  const onRegisterButton = useCallback(() => {
    openExternalLink(registerUrl);
    onClose?.();
  }, [onClose, openExternalLink, registerUrl]);

  const onConnectButton = useCallback(() => {
    onClose?.();

    if (Target.__MOBILE__) {
      history.push(RoutesRedirectionFactory.getLoginRouteConfig());
    } else {
      history.push(RoutesRedirectionFactory.getHomeRouteConfig());

      global.showLoginForm();
    }
  }, [history, onClose]);

  const displayTerms = useMemo(() => Locales.FR === lang, [lang]);
  const registrationImage = useMemo(() => {
    switch (lang) {
      case Locales.DE:
        return Target.__MOBILE__ ? DERegistrationImageMobile : DERegistrationImageDesktop;
      case Locales.FR:
        return Target.__MOBILE__ ? FRRegistrationImageMobile : FRRegistrationImageDesktop;
      case Locales.EN:
      default:
        return Target.__MOBILE__ ? ENRegistrationImageMobile : ENRegistrationImageDesktop;
    }
  }, [lang]);

  return (
    <RegisterDefaultModal
      img={registrationImage}
      onRegisterButton={onRegisterButton}
      onConnectButton={onConnectButton}
      displayTerms={displayTerms}
      onClose={onClose}
    />
  );
};

export default RegisterModal;
